import { animateScroll } from 'react-scroll';
const scrollToTop = () => {
  const scroll = animateScroll;
  scroll.scrollTo(30);
};
export default scrollToTop;
